import { render, staticRenderFns } from "./CompareModal.vue?vue&type=template&id=42928dd0"
import script from "./CompareModal.vue?vue&type=script&lang=js"
export * from "./CompareModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports